import { makeStyles } from "@material-ui/core/styles";
import { Color } from "../../../constants/colors";


export const useStyles = makeStyles((theme) => ({
  addCertificationsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 100,
    marginTop: 15,
    marginLeft: 50
  },
  certificationsNotesContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: 430,
    height: 42,
  },
  deleteButton: {  
    minWidth: 16,
    height: 16,
  },
  addButton: {
    ...theme.typography.buttons,
    fontWeight: 700,
    color: theme.colors.clearMain,
    minWidth: 162,
    height: 24,
    borderRadius: 5,
    padding: "11px 16px",
    borderWidth: 1,
    borderColor: theme.colors.clearMain,
    border: "solid",
    justifyContent: "space-around",
    "&:disabled": {
      color: theme.colors.grey4,
      borderColor: theme.colors.grey4,
      opacity: 0.3
    }
  },
  addButtonItems: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 10
  },
  notesBoldText: {
    fontFamily: "Roboto,sans serif",
    fontWeight: 700,
    fontSize: 12,
    color: theme.colors.grey5
  },
  notesText: {
    fontFamily: "Roboto,sans serif",
    fontWeight: 400,
    fontSize: 12,
    color: theme.colors.grey5
  },
  certificationsContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 162,
    maxWidth: 180,
  },
  certificationHiddenContainer: {
    display: "none"
  },
  certificationContainer: {
    display: "flex",
    height: 24,
    padding: "8px 16px",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 4,
    backgroundColor: "#FAFAFA"
  },
  certificationName: {
    fontFamily: "Roboto,sans serif",
    color: theme.colors.grey4,
    fontSize: 10,
    fontWeight: 700,
    overflow: "hidden",
    wordWrap: "break-word",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
  },
  modalDelete: {
    height: 220
  },
  modalCenter: {
    display: "flex",
    justifyContent: "center",
  },
  modalTitleSpace: {
    margin: "24px 0px 8px 0px",
  },
  modalTitleText: {
    fontSize: 18,
    lineHeight: "22px",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: "bold",
    color: theme.colors.grey7
  },
  rowContainer: {
    display: "flex",
    justifyContent: "flex-start",
    margin: "24px 0px 0px 0px",
  },
  switch: {
    display: "flex",
    alignItems: "center",
  },
  switchLabel: {
    margin: "0px 0px 0px 5px",
    display: "inline-flex",
    verticalAlign: "middle"
  },
  switchRoot: {
    width: 32,
    height: 21,
    padding: 0,
  },
  switchBase: {
    padding: 1,
    opacity: 1,
    height: "100%",
    border: "3px solid #323947",
    "&.Mui-checked": {
      transform: "translateX(13px)",
      border: "0px",
      color: Color.white,
      "& + .MuiSwitch-track": {
        opacity: 0.3,
        border: "none",
        backgroundColor: Color.green,
      },
      "& * .MuiSwitch-thumb": {
        width: 15,
      },
      //
    },
    "&.Mui-checked:not(.Mui-disabled)": {
      "& + .MuiSwitch-track": {
        opacity: 1,
      }
    },
    "&$focusVisible .MuiSwitch-thumb": {
      color: "#6462F3",
      border: "6px solid #fff",
    },
    "& * .MuiSwitch-thumb": {
      width: 12,
      height: 15,
      boxShadow: "none",
    },
  },
  switchThumb: {
    width: 12,
    height: 15,
    boxShadow: "none",
  },
  switchTrack: {
    borderRadius: 23 / 2,
    border: "3px solid #323947",
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    // .MuiSwitch-track
  },
  switchChecked: {},
  focusVisible: {},
  rowWeekDays: {
    height: 60
  },
  iconInCheck: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 45,
    paddingLeft: 5
  },
  labelH2: {
    fontFamily: "Roboto, sans-serif",
    display: "flex",
    paddingTop: 7,
    color: "#5C6477",
    fontSize: "14px",
    lineHeight: "14px",
    fontWeight: "bold",
    fontStyle: "normal",
    marginBottom: 5,
  },
}));

